import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import { convertToEChartsOption } from './EChartsConfig';
export class EChartsAdapter {
    chartInstance = null;
    render(config) {
        return _jsx(EChartsWrapper, { config: config, adapter: this });
    }
    update(config) {
        if (!this.chartInstance)
            return;
        const option = convertToEChartsOption(config);
        this.chartInstance.setOption(option, { notMerge: true });
    }
    resize() {
        this.chartInstance?.resize();
    }
    dispose() {
        this.chartInstance?.dispose();
        this.chartInstance = null;
    }
    initialize(container) {
        if (this.chartInstance) {
            this.dispose();
        }
        this.chartInstance = echarts.init(container);
    }
}
const EChartsWrapper = ({ config, adapter }) => {
    const containerRef = useRef(null);
    const previousTypeRef = useRef(null);
    useEffect(() => {
        if (!containerRef.current)
            return;
        adapter.initialize(containerRef.current);
        adapter.update(config);
        previousTypeRef.current = config.type;
        const handleResize = () => {
            adapter.resize();
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            adapter.dispose();
        };
    }, []);
    useEffect(() => {
        if (!containerRef.current)
            return;
        const typeChanged = previousTypeRef.current !== null && previousTypeRef.current !== config.type;
        if (typeChanged) {
            adapter.dispose();
            adapter.initialize(containerRef.current);
            previousTypeRef.current = config.type;
        }
        adapter.update(config);
    }, [config.type, config, adapter]);
    return (_jsx("div", { ref: containerRef, style: {
            width: config.width ?? '100%',
            height: config.height ?? 400,
        } }));
};
